import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import ProlinkSettingsHtml from './prolink.settings.html';

export function ProlinkStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'ProlinkSettingsCtrl',
    name       : 'app.prolink-settings',
    templateUrl: ProlinkSettingsHtml,
    url        : '/prolink_settings',
    resolve    : {
      session : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company')
    }
  });
}